export const releaseMediaElement = (mediaElement) => {
    if (!mediaElement) {
        return;
    }

    mediaElement.pause();
    mediaElement.removeAttribute("src");
    mediaElement.querySelectorAll?.("source").forEach((sourceElement) => {
        sourceElement.removeAttribute("src");
    });
    mediaElement.load();
};
